const merge = require("merge");
import prodEnv from './prod.env'
export default merge(true,prodEnv, {
	api_url:"http://192.168.0.101:83/",
	// api_url:"http://lfct.101.0373cy.com:8889/",
});
